export default __webpack_public_path__ + "static/media/francheville19.600b61ab.jpg";